import { NotificationItemProps } from "apis";
import { lazy } from "react";

export const PageAdminNotification = lazy(() => import("./List"));
export const PageAdminNotificationCreate = lazy(() => import("./Add"));
export const PageAdminNotificationUpdate = lazy(() => import("./Edit"));

export interface FormNotificationValuesProps extends NotificationItemProps { }